import { render, staticRenderFns } from "./pricehelp.vue?vue&type=template&id=2a376f4b&"
import script from "./pricehelp.vue?vue&type=script&lang=js&"
export * from "./pricehelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2a376f4b')) {
      api.createRecord('2a376f4b', component.options)
    } else {
      api.reload('2a376f4b', component.options)
    }
    module.hot.accept("./pricehelp.vue?vue&type=template&id=2a376f4b&", function () {
      api.rerender('2a376f4b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2EHctW4Z0hvmJ/JS/pricehelp.vue"
export default component.exports